<template>
  <div class="card">
    <div class="card-header padding_12_20">
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
          <div class="me-3">
            <img src="@/assets/images/svg-img/generation.svg" />
          </div>
          <div>
            <div class="card_title_1">FUEL MIX</div>
            <div class="card_title_2">Last Updated {{ last_update }}</div>
          </div>
        </div>
        <div></div>
      </div>
    </div>

    <div class="card-body">
      <apexchart
        type="bar"
        height="350"
        :options="barChartOptions"
        :series="fuelmix"
      ></apexchart>
    </div>
  </div>
</template>

<script>
import GenerationService from "@/services/generation/generation";
const apiGeneration = GenerationService.build();

export default {
  props: ["last_update"],
  data() {
    return {
      fuelmix: [],
      barSeries: [
        {
          name: "BBM",
          data: [44, 55, 41, 37, 22, 43, 21],
        },
        {
          name: "Batu Bara",
          data: [53, 32, 33, 52, 13, 43, 32],
        },
        {
          name: "Gas Alam",
          data: [12, 17, 11, 9, 15, 11, 20],
        },
        {
          name: "Panas Bumi",
          data: [9, 7, 5, 8, 6, 9, 4],
        },
        {
          name: "Air",
          data: [25, 12, 19, 32, 25, 24, 10],
        },
        {
          name: "EBT",
          data: [25, 12, 19, 32, 25, 24, 10],
        },
        {
          name: "Lainnya",
          data: [25, 12, 19, 32, 25, 24, 10],
        },
      ],
      barChartOptions: {
        chart: {
          type: "bar",
          height: 350,
          stacked: true,
          stackType: "100%",
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            dataLabels: {
              position: "bottom",
            },
          },
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          categories: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ],
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val + "K";
            },
          },
        },
        fill: {
          opacity: 1,
        },
        legend: {
          position: "right",
          horizontalAlign: "right",
          offsetX: 40,
        },
      },
    };
  },
  mounted() {
    this.getDataGenerationFuelMix();
  },
  methods: {
    async getDataGenerationFuelMix() {
      const res = await apiGeneration.getDataGenerationFuelMix();
      if (res && res.status == 200) {
        this.fuelmix = res.data.data.map((item) => ({
          name: item.metricName,
          data: item.listItem,
          color: item.color,
        }));
      }
    },
  },
};
</script>
